export class ConvertHourToInt {
  Parse(time) {
    return (parseInt(time[0], 10) * 3600) + (parseInt(time[1], 10) * 60) + parseInt(time[2], 10)
  }
}



// WEBPACK FOOTER //
// ./src/js/helpers/Utils/ConvertHourToInt.js